var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('div',{staticClass:"w-full py-2 px-3 sm:px-7"},[_c('div',{staticClass:"text-primary font-bold text-x"},[_vm._v(" Home "),_c('span',{staticClass:"text-black font-medium"},[_vm._v("|")]),_vm._v(" "+_vm._s(_vm.page)+" "),_c('span',{staticClass:"text-black font-medium"},[_vm._v("| "+_vm._s(_vm.subPage))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }